module.exports = __webpack_public_path__ + "img/paper.ec703fe7.svg";